import { memo, useState } from "react";
import { Col, Row, Card, Spin, Table } from "antd";
import TopApplicationChart from "./TopApplicationChart";
import SavingsCastChart from "./SavingsCastChart";
import { Icon } from "@iconify/react";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import {
  getListSavingOppurtunitySummary,
  listRecommendation,
} from "../../action/costimizeV2Active";
import { numberFormat } from "../../custom_hook/CustomHook";

const CostSavings = () => {
  const {
    selectedEnvironment,
    selectedAccount,
    selectedCloud,
    selectedApplication,
    selectedTopdate,
    selectedservices,
    selectedos,
    selectedinfra,
    selecteddb,
  } = useSelector((state) => state.constimize);
  const dispatch = useDispatch();
  const companyName = localStorage.getItem(
    "CognitoIdentityServiceProvider.company"
  );

  //state
  const [toprecords, setTopRecords] = useState({
    potential_savings: 0,
    realised_savings: 0,
    pending_action: "0/0",
    color_code: "#000",
  });
  const [savingslist, setSavingsList] = useState([]);
  //status
  const [lsavigsstatus, setLSavingsStatus] = useState(true);
  const [savingsTableData, setSavingsTableData] = useState([]);
  useEffect(() => {
    setLSavingsStatus(true);
    var apivalue = {
      environment: selectedEnvironment.toString(),
      account: selectedAccount.toString(),
      cloud: selectedCloud.toString(),
      application: selectedApplication.toString(),
      services: selectedservices.toString(),
      os: selectedos.toString(),
      infra: selectedinfra.toString(),
      db: selecteddb.toString(),
      date: selectedTopdate,
    };

    dispatch(listRecommendation({ companyName, apivalue }))
      .unwrap()
      .then(({ data }) => {
        var potential_list = [];
        var realised_list = [];
        setSavingsList(data.newfunctionquery10);
        data.newfunctionquery10.map((map_data) => {
          if (
            map_data.realised_savings === null ||
            Math.round(map_data.realised_savings) === 0
          ) {
            potential_list.push(map_data);
          } else {
            realised_list.push(map_data);
          }
        });
        const pending_action =
          data.newfunctionquery10.length - realised_list.length;
        var pending_percentage =
          (pending_action * 100) / data.newfunctionquery10.length;
        var color_code = "#000";
        if (pending_percentage >= 50) {
          color_code = "#be1e2d";
        } else if (pending_percentage >= 30) {
          color_code = "#FFA500";
        } else {
          color_code = "#188f00";
        }
        setTopRecords({
          potential_savings: Math.round(
            potential_list?.reduce((a, v) => (a = +a + +v.potential_savings), 0)
          ),
          realised_savings: Math.round(
            realised_list?.reduce((a, v) => (a = +a + +v.realised_savings), 0)
          ),
          pending_action: `${
            data.newfunctionquery10.length - realised_list.length
          }/${data.newfunctionquery10.length}`,
          color_code: color_code,
        });
        setLSavingsStatus(false);
      })
      .catch((err) => {
        setLSavingsStatus(false);
      });

    dispatch(getListSavingOppurtunitySummary({ companyName, apivalue }))
      .unwrap()
      .then(({ data }) => {
        setSavingsTableData(data.saving_opportunity_summary);
      })
      .catch((err) => {
        setLSavingsStatus(false);
      });
  }, [
    selectedEnvironment,
    selectedAccount,
    selectedCloud,
    selectedApplication,
    selectedservices,
    selectedos,
    selectedinfra,
    selecteddb,
    selectedTopdate,
  ]);
  const columns = [
    {
      title: "Recommendation Rule",
      dataIndex: "recommendation_rule",
      key: "recommendation_rule",
      align: "left",
      width: "42%",
    },
    {
      title: "Resources",
      dataIndex: "resource",
      key: "resource",
      key: "resource",
      align: "right",
      width: "24%",
    },
    {
      title: "Potential Savings",
      dataIndex: "potential_savings",
      key: "potential_savings",
      align: "right",
      width: "35%",
    },
  ];
  return (
    <>
      <Row className="mt-3">
        <Col>
          <h1 className="site-color block-title">Annual Cost Savings</h1>
        </Col>
      </Row>
      <Row gutter={[16, 16]}>
        <Col xxl={9} xl={9} lg={9} md={9} sm={9} xs={9}>
          <Card className="operate-cards annual-card-height">
            <Spin spinning={lsavigsstatus} wrapperClassName="costimize-loader">
              <Table
                className="slm-table last-col-color"
                columns={columns}
                dataSource={savingsTableData}
                scroll={{ y: 160 }}
              />
            </Spin>
          </Card>
        </Col>
        <Col xxl={5} xl={5} lg={5} md={5} sm={5} xs={5}>
          <Card
            title="Potential Annual Savings"
            className="operate-cards annual-cost-savings"
          >
            <Spin spinning={lsavigsstatus} wrapperClassName="costimize-loader">
              <div className="">
                <h1 className="card-2-value ">
                  {/* <Icon
                        icon="guidance:bank"
                        className="quick-glance-icon"
                      /> */}

                  <Icon
                    icon="ant-design:message-filled"
                    className="quick-glance-icon"
                  />
                  <label className="cardnumber">
                    {toprecords.potential_savings === 0
                      ? `$0`
                      : `$${numberFormat(toprecords.potential_savings)}`}
                  </label>
                </h1>
              </div>
            </Spin>
          </Card>
          <Card
            title="Pending Actions"
            className="operate-cards annual-cost-savings"
          >
            <Spin spinning={lsavigsstatus} wrapperClassName="costimize-loader">
              <div className="">
                <h1 className="card-2-value ">
                  {/* <Icon
                        icon="guidance:bank"
                        className="quick-glance-icon"
                      /> */}
                  <Icon
                    icon="mdi:timer-sand-complete"
                    className="quick-glance-icon"
                  />
                  <span>{toprecords.pending_action}</span>
                </h1>
              </div>
            </Spin>
          </Card>
          <Card
            title="Realised Annual Savings"
            className="operate-cards annual-cost-savings"
          >
            <Spin spinning={lsavigsstatus} wrapperClassName="costimize-loader">
              <div className="">
                <h1 className="card-2-value ">
                  {/* <Icon
                        icon="guidance:bank"
                        className="quick-glance-icon"
                      /> */}
                  {/* <Icon
                    icon="ant-design:message-filled"
                    className="quick-glance-icon"
                  /> */}
                  {toprecords.realised_savings === 0
                    ? `$0`
                    : `$${numberFormat(toprecords.realised_savings)}`}
                </h1>
              </div>
            </Spin>
          </Card>
        </Col>
        <Col xxl={10} xl={10} lg={10} md={10} sm={8} xs={8}>
          <Card className="operate-cards annual-card-height">
            <SavingsCastChart
              savingslist={savingslist}
              lsavigsstatus={lsavigsstatus}
            />
          </Card>
        </Col>
      </Row>
    </>
  );
};
export default memo(CostSavings);
